module.exports = __webpack_public_path__ + "img/report-monitoring.svg";